import Title from './Title';
import Icon from './Icon';
export default (Vue)=>{
    Vue.component("Icon",Icon)
    Vue.component("pageTitle",Title)
}


// WEBPACK FOOTER //
// ./src/plugins/components.js